import { useState, useEffect } from "react";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import CustomerNavBar from './CustomerNavBar'
import Toast from './Toast'
import TabNavBar from './TabNavBar'
import SiteNoti from './SiteNoti'
import RoomDesignEditForm from './RoomDesignEditForm'
import SelectRoomType from './SelectRoomType'
import SelectLifestyle from './SelectLifestyle'
import CreateRoomDesignConfirm from './CreateRoomDesignConfirm'
import RegenRoomDesignConfirm from './RegenRoomDesignConfirm'
import RoomDesignConfirmClearAll from './RoomDesignConfirmClearAll'
import RoomDesignPhotoTooBigPopup from './RoomDesignPhotoTooBigPopup'
import RoomDesignEditPhotoPopup from "./edit_after_photo/RoomDesignEditPhotoPopup";
import RoomDesignSaveChangesConfirm from "./edit_after_photo/RoomDesignSaveChangesConfirm";
import RoomDesignDiscardChangesConfirm from "./edit_after_photo/RoomDesignDiscardChangesConfirm";
import ItemRemovalForm from './item_removal/ItemRemovalForm'
import ItemRemovalModals from './item_removal/ItemRemovalModals'
import ImageEditingForm from './image_editing/ImageEditingForm'
import {siteNotiActions} from '../reducers/siteNoti'
import {roomDesignActions} from '../reducers/roomDesign'
import {itemRemovalActions} from '../reducers/itemRemoval'
import {imageEditingActions} from '../reducers/imageEditing'

function mapStateToProps(state: any) {
  return {}
}

const NewRoomDesign = () => {
  const [activeTab, setActiveTab] = useState('roomDesign') // 'roomDesign' または 'itemRemoval'
  const navigate = useNavigate()
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()

  useEffect(() => {
    // 共通の初期化処理
    dispatch(siteNotiActions.getSiteNoti())

    // 初回マウント時のみ初期化処理を実行
    const currentTab = activeTab; // 現在のアクティブタブを取得
    if (currentTab === 'roomDesign') {
      dispatch(roomDesignActions.setInitState())
    } else if (currentTab === 'itemRemoval') {
      dispatch(itemRemovalActions.clearData())
    } else if (currentTab === 'imageEditing') {
      dispatch(imageEditingActions.setInitState())
    }

    // タブ切り替えによる初期化を防止するため、activeTabを依存配列から削除
  }, [dispatch])

  // タブが変更されたときの処理
  const handleTabChange = (tabName: string) => {
    // タブを変更するだけで、データの初期化は行わない
    setActiveTab(tabName);
  };

  return (
    <>
      <Toast />
      <CustomerNavBar />
      <div className="w-screen">
        <div className="py-3 px-4 sm:px-6 md:px-8">
          <SiteNoti />
        </div>
        <TabNavBar activeTab={activeTab} onTabChange={handleTabChange} />
        {activeTab === 'roomDesign' && (
          // 既存の部屋デザイン機能
          <>
            <RoomDesignEditForm />
            <SelectRoomType />
            <SelectLifestyle />
            <CreateRoomDesignConfirm />
            <RegenRoomDesignConfirm />
            <RoomDesignConfirmClearAll />
            <RoomDesignPhotoTooBigPopup />
            <RoomDesignEditPhotoPopup />
            <RoomDesignSaveChangesConfirm />
            <RoomDesignDiscardChangesConfirm />
          </>
        )}

        {activeTab === 'itemRemoval' && (
          // 新しい家具除去機能
          <>
            <ItemRemovalForm />
            <ItemRemovalModals />
          </>
        )}

        {activeTab === 'imageEditing' && (
          // 新しい画像編集機能
          <>
            <ImageEditingForm />
          </>
        )}
      </div>
    </>
  );
};

export default connect(mapStateToProps)(NewRoomDesign)